export default {
  metaTitle: "USFans Spreadsheet 2026 : guide complet et ce qu'il faut savoir",
  metaDescription:
    "Un guide indépendant complet de la USFans Spreadsheet : ce que c'est, comment ça marche, catégories principales, conseils d'achat, QC, expédition et sécurité. Mis à jour 2026.",
  breadcrumbHome: "Accueil",
  breadcrumbCurrent: "Guide USFans Spreadsheet",
  h1: "USFans Spreadsheet 2026 : guide complet et ce qu'il faut savoir",
  shortAnswerLabel: "Réponse courte",
  shortAnswer:
    "La USFans Spreadsheet est une ressource produits organisée qui vous aide à découvrir des trouvailles, comparer les catégories et comprendre comment acheter mieux — avant de passer commande.",
  intro1:
    "Si vous cherchiez une façon claire et honnête d'explorer les trouvailles USFans, vous êtes au bon endroit. Ce guide explique ce qu'est la USFans Spreadsheet, comment elle fonctionne et comment l'utiliser pour prendre des décisions d'achat plus sûres.",
  intro2:
    "Nous gardons cette ressource indépendante et pratique. Vous n'y trouverez pas de promesses exagérées — juste des informations simples sur les catégories, le QC, l'expédition et la sécurité, pour parcourir en toute confiance.",
  tocTitle: "Sommaire",
  toc1: "Qu'est-ce que la USFans Spreadsheet ?",
  toc2: "Comment fonctionne la USFans Spreadsheet",
  toc3: "Les principales catégories que vous trouverez",
  toc4: "Un guide d'achat rapide",
  toc5: "Les bases du QC, de l'expédition et de l'entrepôt",
  toc6: "USFans est-il légitime et sûr ?",
  s1Title: "Qu'est-ce que la USFans Spreadsheet ?",
  s1Body:
    "La USFans Spreadsheet est une collection organisée de liens et de ressources produits, classée par catégorie. Au lieu de fouiller des pages dispersées, vous pouvez accéder directement à la section souhaitée — des chaussures et sweats aux sacs et accessoires. L'objectif est simple : rendre la découverte de produits plus rapide et moins confuse.",
  s2Title: "Comment fonctionne la USFans Spreadsheet",
  s2Body:
    "La feuille est organisée par catégorie, vous savez donc toujours où chercher. Choisissez une catégorie, parcourez les trouvailles disponibles et suivez les liens vers le site principal pour voir les détails, prix et disponibilités actuels. Comme les informations changent souvent, vérifiez toujours les derniers détails sur les pages liées avant d'acheter.",
  s3Title: "Les principales catégories que vous trouverez",
  s3Body:
    "Vous trouverez plus d'une douzaine de catégories, dont Chaussures, Sweats et Pulls, T-shirts, Vestes, Pantalons et Shorts, Couvre-chefs, Ensembles, Sous-vêtements, Maillots, Accessoires, Sacs, Ceintures, Parfums et Autres articles. Chaque catégorie regroupe des produits similaires pour comparer les options sans jongler entre de nombreux onglets.",
  s4Title: "Un guide d'achat rapide",
  s4Body:
    "Avant de commander, suivez quelques étapes simples. D'abord, vérifiez soigneusement les photos du produit. Ensuite, consultez le guide des tailles s'il est disponible. Puis comparez quelques articles similaires avant de vous décider. Enfin, confirmez le prix actuel et les détails d'expédition sur le site principal — ils peuvent évoluer avec le temps.",
  s5Title: "Les bases du QC, de l'expédition et de l'entrepôt",
  s5Body:
    "Beaucoup d'acheteurs s'interrogent sur le QC (contrôle qualité), l'expédition et la gestion de l'entrepôt. En termes simples, le QC consiste à examiner les photos du produit avant de l'approuver, l'expédition dépend du poids, des dimensions et de la destination, et l'entrepôt est l'endroit où les articles sont stockés et préparés avant de vous être envoyés. Comprendre ces bases vous évite des surprises.",
  s6Title: "USFans est-il légitime et sûr ?",
  s6Body:
    "C'est une question légitime avant tout achat en ligne. Nous ne faisons aucune affirmation absolue sur la sécurité, et aucune plateforme n'est exempte de risques. La meilleure approche consiste à vérifier les détails du produit, contrôler les informations du vendeur, examiner les photos QC et lire les politiques en vigueur avant de commander. La prudence est le moyen le plus efficace de vous protéger.",
  tableTitle: "Fonctions clés en un coup d'œil",
  tableCol1: "Fonction",
  tableCol2: "À savoir",
  tableCol3: "Point important",
  t1c1: "Découverte de produits",
  t1c2: "Feuille / ressources",
  t1c3: "Vérifiez les infos actuelles",
  t2c1: "QC",
  t2c2: "Ressources d'inspection",
  t2c3: "Examinez les photos avec soin",
  t3c1: "Expédition",
  t3c2: "Plusieurs facteurs",
  t3c3: "Les coûts varient selon la destination",
  t4c1: "Retours",
  t4c2: "Selon la politique",
  t4c3: "Vérifiez les conditions actuelles",
  faqTitle: "Questions fréquentes",
  faq1Q: "Qu'est-ce que la USFans Spreadsheet ?",
  faq1A:
    "C'est une ressource organisée qui regroupe les trouvailles produits USFans par catégorie, pour parcourir et comparer les options plus facilement au même endroit.",
  faq2Q: "Parcourir la USFans Spreadsheet est-il gratuit ?",
  faq2A:
    "La ressource elle-même est gratuite. Il vous suffit de consulter le site principal pour connaître les détails, prix et disponibilités actuels des produits.",
  faq3Q: "Ai-je besoin d'un compte pour utiliser la feuille ?",
  faq3A:
    "La consultation ne nécessite pas de compte. Si vous décidez d'acheter, suivez les liens vers le site principal et terminez le paiement là-bas.",
  faq4Q: "À quelle fréquence la feuille est-elle mise à jour ?",
  faq4A:
    "Nous nous efforçons de garder la ressource organisée et à jour. Cependant, les détails des produits changent souvent, alors vérifiez toujours les dernières informations sur les pages liées.",
  faq5Q: "USFans est-il sûr à utiliser ?",
  faq5A:
    "Nous ne pouvons pas garantir la sécurité d'une plateforme. Restez prudent, vérifiez les détails et lisez les politiques en vigueur avant de commander.",
  ctaTitle: "Continuer à explorer",
  ctaSub: "Prêt à parcourir ? Rendez-vous sur le site principal ou revenez à l'accueil pour plus de guides.",
  ctaPrimary: "Explorer la USFans Spreadsheet",
  ctaSecondary: "Retour à l'accueil",
  updatedLabel: "Dernière mise à jour :",
  updatedValue: "2026",
  authorLabel: "Rédigé et relu par l'équipe éditoriale USFansSheet",
  disclaimerTitle: "Avertissement",
  disclaimerBody:
    "Cet article est fourni à titre informatif uniquement. USFansSheet est une ressource indépendante, non affiliée à USFans. Vérifiez toujours les détails, prix et politiques en vigueur sur les pages officielles avant tout achat.",
};